module.exports = __webpack_public_path__ + "img/invest_list1.6f9655f7.png";